import { Box, Grid, Typography, useTheme } from '@mui/material';
import { IconPhoneBook } from '@shared/assets/images/svgs';
import { CampaignDto } from '@shared/services/apiService';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import { CreateCampaignFormValue } from '@features/Admin/Campaign/model/type';
import { PhoneNumberList } from '@pages/Admin/Main/PhoneNumbers/PhoneNumberList';

interface PhoneNumbersTabProps {
  campaign?: CampaignDto | null;
  refetch: () => void;
  responseLoadingFlag: boolean;
  setLeadListChanged: (changed: boolean) => void;
  customersRefreshKey: number;
  actions?: React.ReactNode;
}

const PhoneNumbersTab: React.FC<PhoneNumbersTabProps> = ({
  campaign,
  responseLoadingFlag,
  setLeadListChanged,
  customersRefreshKey,
  actions,
}) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<CreateCampaignFormValue>();
  const theme = useTheme();

  useController({ control, name: 'customers' });
  useController({ control, name: 'customerListChanged' });

  const isCampaignRunning = ['active', 'finishing'].includes(campaign?.status as string);

  const handleLeadListChanged = (changed: boolean) => {
    setLeadListChanged(changed);
    setValue('customerListChanged', changed, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  return (
    <Grid
      container
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 2, sm: 3 },
        boxSizing: 'border-box',
        flexDirection: 'column',
        minWidth: 0,
        width: '100%',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          marginBottom: '20px',
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            'svg path': {
              stroke: theme.palette.getContrastText(theme.palette.background.default),
            },
          }}>
          <IconPhoneBook />
          <Typography fontSize="18px" fontWeight={600}>
            {t('campaignPage.phoneNumbers')}
          </Typography>
        </Box>
        {actions}
      </Box>
      <PhoneNumberList
        campaignId={campaign?.id}
        setCustomersListChanged={handleLeadListChanged}
        responseLoadingFlag={responseLoadingFlag}
        isCampaignActive={isCampaignRunning}
        refreshKey={customersRefreshKey}
      />
    </Grid>
  );
};

export default PhoneNumbersTab;
